<template>
  <main id='wrapper'>
    <MainNav />
    <FontPane v-if="route.name !== 'Home'" />
    <ViewTransitions @transitionStarted="started" @transitionEnded="ended"/>

    <!-- Persistent cover overlay: bridges the index → project route change.
         Index sets it; Project clears it once its first slide has painted.
         The leave transition creates a crossfade: overlay and project slide
         are both visible simultaneously while the overlay fades out. -->
    <Transition name="cover-fade">
      <div v-if="transitionCover" class="cover-transition-overlay">
        <img
          :src="transitionCover.url"
          :srcset="transitionCover.srcset"
          sizes="(max-width: 700px) 90vw, 90vw"
        />
      </div>
    </Transition>
  </main>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import { routeStore } from '@/utils'
import { transitionCover } from '@/composables/useTransitionCover'

const route = useRoute();
const routes = routeStore();

const kql = useStore();
setTimeout(function() {
  kql.loadPageAndSite(route.path, route.name);
  kql.loadPage(route.path, route.name);
});

watch(() => route.path, () => kql.loadPage(route.path, route.name));

const transitionActive = ref(false)
const started = () => {transitionActive.value = true}
const ended = () => {transitionActive.value = false}
</script>

<style scoped>
  main {
    position: relative;
    min-height: 100%;
  }

  /* Same stage bounds as .stage — sits above slides (z-index 2) but below nav (10) */
  .cover-transition-overlay {
    position: fixed;
    top: calc(var(--page-margin, 28px) + 1.5rem);
    bottom: var(--page-margin, 28px);
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    z-index: 2;
  }

  .cover-transition-overlay img {
    max-height: 75vh; /* match archive-stage — prevents size jump when overlay snaps in */
    max-width: 90vw;
    object-fit: contain;
    display: block;
  }

  @media only screen and (max-width: 700px) {
    .cover-transition-overlay {
      top: 0;
      height: 100svh;
      bottom: auto;
      padding-bottom: 0;
    }

    .cover-transition-overlay img {
      max-height: 100%; /* fill the 100svh container on mobile */
    }
  }

  /* Fade out only — the overlay snaps in instantly but dissolves into the slide */
  .cover-fade-leave-active {
    transition: opacity 200ms ease;
  }
  .cover-fade-leave-to {
    opacity: 0;
  }
</style>
